import { getPrimaBrandName } from '@/helpers/BrandHelper'
import UrlHelper from '@/helpers/url/UrlHelper'

class PrimaUrlHelper {
  constructor(baseUrl) {
    this.url = baseUrl + '/search'
    this.queryParams = []
    this.modelDataParams = []
  }

  /**
   * Query parameters:
   * brand ex. Volkswagen
   * modelYear ex. 2022
   * modelGeneration ex. Passat Variant (8)
   * trimLine ex. GTE Business
   */

  buildPrimaParams(query) {
    const brand = getPrimaBrandName()
    this.addParam('brand', brand)
    this.addParam('model', query.modelName)
    this.addParam('modelGeneration', query.modelType)
    this.addParam('modelYear', query.modelYear)
    this.addParam('trimline', query.trimline)

    return `${this.url}?${this.queryParams.join('&')}`
  }

  addParam(name, value) {
    value = name == 'q' && !value ? '**' : UrlHelper.encodeParam(value)
    this.queryParams.push(`${name}=${value}`)
  }
}

export default PrimaUrlHelper
